var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcForwardArticle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.057 5.724c.52-.521 1.365-.521 1.886 0l6.666 6.666c.521.52.521 1.365 0 1.886l-6.666 6.666a1.333 1.333 0 1 1-1.886-1.885l5.724-5.724-5.724-5.724a1.333 1.333 0 0 1 0-1.885",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.667 14.666a4 4 0 0 0-4 4V24A1.333 1.333 0 1 1 4 24v-5.334A6.667 6.667 0 0 1 10.667 12h16a1.333 1.333 0 0 1 0 2.666z",
  clipRule: "evenodd"
})));
export default SvgIcForwardArticle;